// for mocking in tests
export function getHostname() {
  return window.location.hostname;
}
export function getPathname() {
  return window.location.pathname;
}
export function isWebdriver() {
  return window.navigator.webdriver;
}